export const SET_LOADING_STATUS = 'information.SET_LOADING_STATUS';
export const FETCH_TICKERS = 'information.FETCH_TICKERS';
export const FETCH_MARKETS = 'information.FETCH_MARKETS';
export const FETCH_DATES = 'information.FETCH_DATES';
